import { type Common } from './common.js';
import {
  type DiagnosticResults,
  type RetrieveAppointmentDiagnostics,
} from './models/diagnostics.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async retrieveAppointments(args: RetrieveAppointmentDiagnostics): Promise<DiagnosticResults> {
    const url = this.common.constructPath(`/diagnostics/appointments-results`, args);
    return await this.common
      .authedFetch(url)
      .then((res) =>
        res.json().then((json) => ({
          headers: res.headers,
          json,
        }))
      )
      .then(({ headers, json }) => {
        return {
          ...json,
          trace: headers.get('X-Cloud-Trace-Context')?.split('/')?.[0] ?? undefined,
        };
      });
  }
}
